/*
MIT License

Copyright (c) 2016-2017 Grall Arnaud

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the 'Software'), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
'use strict'

const PassThrough = (require('readable-stream')).PassThrough

/**
 * A StreamMessage enable to receive data streamed using a {@link StreamRequest}.
 * @extends PassThrough
 * @author Thomas Minier
 * @example
 * const foglet = getSomeFoglet();
 * foglet.onStreamUnicast((id, stream) => {
 *  console.log('a peer with id = ', id, ' is streaming data to me');
 *  stream.on('data', data => console.log(data));
 *  stream.on('end', () => console.log('no more data available from the stream'));
 * });
 */
class StreamMessage extends PassThrough {
  /**
   * Constructor
   */
  constructor () {
    super({
      objectMode: true
    })
    this._trailers = null
  }

  /**
   * Get the trailing data of the message.
   * Only populated once the `end` event has been fired.
   * @return {Array} Message trailing data
   */
  get trailers () {
    return this._trailers
  }
}

module.exports = StreamMessage
